import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { Alert, Grid, Typography } from 'hephaestus/web';

export const SettingsTitle = ({
  title,
  description,
}: {
  title: string;
  description?: string;
}) => (
  <>
    <Typography variant='headingLarge' sx={{ mb: description ? 1 : 2 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant='bodyLarge' color='textSecondary' sx={{ mb: 2 }}>
        {description}
      </Typography>
    )}
  </>
);

export const SettingsCard = ({
  title,
  description,
  children,
  highlightInfo,
}: {
  title: string;
  description: string;
  children: React.ReactNode;
  highlightInfo?: React.ReactNode;
}) => (
  <Card sx={{ maxWidth: '1440px', overflow: 'visible' }}>
    <CardContent sx={{ p: 3 }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <SettingsTitle title={title} description={description} />
          {highlightInfo && (
            <Alert severity='info' icon={false}>
              {highlightInfo}
            </Alert>
          )}
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>{children}</Grid>
      </Grid>
    </CardContent>
  </Card>
);
